"use client";

export type AccessLevel = "read" | "read_write" | "admin";

export function hasPermission(permissions: string[] | undefined, permission: string) {
  return Boolean(permissions?.includes(permission));
}

export function inferAccessLevel(permissions: string[] | undefined): AccessLevel {
  if (hasPermission(permissions, "admin:access") || hasPermission(permissions, "reports:delete")) {
    return "admin";
  }
  if (hasPermission(permissions, "reports:create") || hasPermission(permissions, "reports:update")) {
    return "read_write";
  }
  return "read";
}
